import{styled as t}from"styled-components";const e=t.div`
  padding-inline: 5px;
  overflow: clip;
  text-overflow: ellipsis;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
`,n=t(e)`
  white-space: nowrap;
  justify-content: ${({$textAlign:t})=>"right"===t?"flex-end":"flex-start"};
  border-right: 1px solid #cccccc;
`,c=t(e)`
  z-index: 2;
  white-space: wrap;
  justify-content: center;
  text-align: center;
  position: sticky;
  inset-block-start: 0px;
  border-inline-end: 1px solid #cccccc;
  background: url(images/fhbg.png) repeat-x scroll center bottom #fafafa;
`;export{n as BodyCell,c as HeaderCell};
